import CircularProgress from '@mui/material/CircularProgress';

export const BlkCircularProgress = () => {
  return <CircularProgress sx={{ color: '#0d1523' }} />;
};
